export const ALGOLIA_USER_TOKEN_COOKIE = '_algolia_id';
export const CONTACT_EMAIL_COOKIE = '_ce';
export const CUSTOMER_ORDER_COUNT_COOKIE = '_co';
export const USER_EMAIL_COOKIE = '_e';
